import ProductsBreadCrumbs from './ProductsBreadCrumbs';

export default ProductsBreadCrumbs;
